<template>

    <div class="container-fluid fixcontent " >

        <div class="row " style="margin-top: 1px; margin-bottom: -4px !important;" >
            <div class="col-md-2 text-light " style="padding-left: 0px !important;">
                <img class="col-md-12   " src="@/assets/images/headerlogo.png"   >
            </div>
            <div class="col-md-6 text-center col-7 mt-4 text-light offset-1 font-weight-semi-bold" style="font-size: 17px">
                <welcomenote/>

            </div>
            <div class="col-md-3 text-right col-4 text-light mt-1" style="font-size: 17px" >
                <p style="margin-bottom: 0.3rem"><ShowRealTime/></p>
                <a class="text-light" href="#" >Login</a> / <a class="text-light" href="#" @click.prevent="signOut">Logout</a>
            </div>
        </div>

        <div class="row mt-2">
            <sidebar></sidebar>
            <div class="col-md-11 mt-2 pb-2 bgsecond">

                <div class="row   text-light">

                    <div class="col-md-10 offset-1">

                        <div class="row ">
                            <h1 class=" mt-1 col-md-4 offset-5">
                                <span v-if="actiontype=='Save'">Add</span>
                                <span v-if="actiontype=='Update'">Update</span>
                                 Location </h1>
                        </div>

                        <div class="row mt-3">
                            <div class="col-md-6">
                                <label for="" class="form-label">Location Name <span class="text-danger">*</span></label>
                                <b-form-input v-model="form.location_name" placeholder="Enter location name"></b-form-input>
                            </div>
                            <div class="col-md-6">
                                <label for="" class="form-label">Short Code</label>
                                <b-form-input v-model="form.short_code" placeholder="Enter short code"></b-form-input>
                            </div>
                        </div>

                        <div class="row mt-3">
                            <div class="col-md-6">
                                <label for="" class="form-label">Branch</label>
                                <v-select
                                    v-model="selectedBranch"
                                    class="text-dark"
                                    placeholder="Select Branch"
                                    :options="branchOptions"
                                    label="name"
                                    :reduce="option => option.id"
                                />
                            </div>
                            <div class="col-md-6">
                                <label for="" class="form-label">Franchise</label>
                                <v-select
                                    v-model="selectedFranchisee"
                                    class="text-dark"
                                    placeholder="Select Franchise"
                                    :options="franchiseeOptions"
                                    label="f_name"
                                    :reduce="option => option.id"
                                />
                            </div>
                        </div>

                        <div class="row mt-3">
                            <div class="col-md-6">
                                <label for="" class="form-label">Status</label>
                                <div class="mt-2">
                                    <b-form-checkbox v-model="form.status" switch value="1" unchecked-value="0">
                                        <span class="text-light">{{ form.status === '1' ? 'Active' : 'Inactive' }}</span>
                                    </b-form-checkbox>
                                </div>
                            </div>
                            <div class="col-md-6">
                                <label for="" class="form-label">Description</label>
                                <b-form-input v-model="form.location_description" placeholder="Enter description"></b-form-input>
                            </div>
                        </div>

                        <hr class="bg-light" />

                        <div class="row mt-3">
                            <h5 class="col-md-12">Address Details</h5>
                        </div>

                        <div class="row mt-2">
                            <div class="col-md-6">
                                <label for="" class="form-label">Address 1</label>
                                <b-form-input v-model="form.address_1" placeholder="Enter address 1"></b-form-input>
                            </div>
                            <div class="col-md-6">
                                <label for="" class="form-label">Address 2</label>
                                <b-form-input v-model="form.address_2" placeholder="Enter address 2"></b-form-input>
                            </div>
                        </div>

                        <div class="row mt-3">
                            <div class="col-md-6">
                                <label for="" class="form-label">Post Code</label>
                                <b-form-input v-model="form.post_code" placeholder="Enter post code"></b-form-input>
                            </div>
                        </div>

                        <div class="row " style="margin-top: 40px;">
                            <div class="col-md-4 offset-4">
                                <button  type="button" class="btn custom-btn2 w-100 btn-lg text-light   mt-5 mtmb" @click="save_location" :disabled="saving || fetching "> <span v-if="actiontype=='Update'" >Update</span>  <span v-if="actiontype=='Save'">Save</span> </button>
                            </div>
                        </div>

                    </div>

                </div>

            </div>

        </div>

    </div>

</template>

<script>
import apiService from "@/service/apiService";
import { mapActions } from "vuex";
import { mapGetters } from 'vuex';
import sidebar from "@/components/layout/sidebar";
import axios from "axios";
import Swal from "sweetalert2";
import showrealtime from "@/components/showrealtime";
import URL from "@/constants/baseurl"
import Welcomenote from "@/pages/admin/mypos/welcomenote";
import vSelect from "vue-select";


export default {
    name: "location form",

    components:{Welcomenote, 'v-select': vSelect, 'sidebar': sidebar,'ShowRealTime':showrealtime},
    computed: {
        ...mapGetters(['AuthenticatedUser']),

        authenticatedUser() {
            let user = localStorage.getItem('user');
            user = JSON.parse(user)
            return user
        },
        actiontype(){
            if (this.$route.query.type=='add'){
                return 'Save'
            }
            else if (this.$route.query.type=='edit'){
                return 'Update'
            }
            else {
                return 'View'
            }
        }

    },
    data() {
        return {
            form:{
                location_name:'',
                location_description:'',
                status:'1',
                short_code:'',
                address_1:'',
                address_2:'',
                post_code:'',
            },
            selectedBranch: null,
            selectedFranchisee: null,
            branchOptions: [],
            franchiseeOptions: [],
            saving:false,
            fetching:false,

        };
    },
    async created() {
        this.viewType = this.$route.query.type;
        this.location_id = this.$route.query.id;
        await this.fetchBranches();
        await this.fetchFranchisees();
        if(this.viewType !== 'add'){
            await this.setLocation();
        }

    },
    async mounted() {

    },

    methods: {
        ...mapActions(['login', 'processLogoutManual']),

        async signOut() {
            await this.processLogoutManual();
            window.location.href = this.$router.resolve({ name: "Login" }).href;
        },

        async fetchBranches() {
            try {
                const apiToken = localStorage.getItem('token');
                const response = await fetch(`${URL.BASEURL}/api/get-branches`, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': `Bearer ${apiToken}`
                    },
                    body: JSON.stringify({ page: 1 })
                });
                const res = await response.json();
                this.branchOptions = res.data || [];
            } catch (error) {
                console.error('Error fetching branches:', error);
            }
        },

        async fetchFranchisees() {
            try {
                const apiToken = localStorage.getItem('token');
                const response = await fetch(`${URL.BASEURL}/api/get-franchisees`, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': `Bearer ${apiToken}`
                    },
                    body: JSON.stringify({ page: 1 })
                });
                const res = await response.json();
                this.franchiseeOptions = res.data || [];
            } catch (error) {
                console.error('Error fetching franchisees:', error);
            }
        },

        async save_location() {
            if (!this.form.location_name) {
                Swal.fire('Error', 'Location Name is required.', 'error');
                return;
            }

            const apiToken = localStorage.getItem('token');
            if (apiToken) {
                axios.defaults.headers.common['Authorization'] = `Bearer ${apiToken}`;
            }

            this.saving=true
            try {
                let locationPayload = { ...this.form };
                locationPayload.branch_id = this.selectedBranch;
                locationPayload.franchisee_id = this.selectedFranchisee;

                let api_url=`${URL.BASEURL}/api/add-location`
                if(this.location_id){
                    api_url=`${URL.BASEURL}/api/update-location/${this.location_id}`
                }
                await axios.post(api_url, locationPayload);

                if(this.location_id){
                    await Swal.fire('Success', 'Location updated successfully!', 'success');
                } else {
                    await Swal.fire('Success', 'Location created successfully!', 'success');
                }

                this.$router.push({ path: '/location-management' })

            } catch (error) {
                console.error("Error saving location:", error);
                Swal.fire('Error', 'Failed to save location.', 'error');
            }
            finally {
                this.saving=false
            }
        },

        async setLocation(){
            this.fetching=true
            const {data} = await apiService.get(`/get-location/${this.location_id}`);

            this.form.location_name=data.location_name;
            this.form.location_description=data.location_description;
            this.form.status=data.status;
            this.form.short_code=data.short_code;
            this.form.address_1=data.address_1;
            this.form.address_2=data.address_2;
            this.form.post_code=data.post_code;
            this.selectedBranch = data.branch_id;
            this.selectedFranchisee = data.franchisee_id;

            this.fetching=false
        },
    }
};
</script>

<style scoped>
@import '../../../assets/styles/pos.css';
.hide {
    visibility: hidden !important;
}

</style>
